import React from "react";
import Line from "../assets/img/Line.png";
import Image1 from "../assets/img/image_4.png";

const Phase2 = () => {
  return (
    <>
      {/* <div class="min-h-screen bg-gray-100 flex items-center">
    </div> */}
      <div className="md:flex justify-between  my-3">
        <div className="flex font-semibold gap-3 justify-center items-center">
          <img src={Line} alt="" className="h-7" />
          <h1 className="text-[#22345C] text-[20px]">Visual Presentation</h1>
        </div>
      </div>
      <div className="md:flex justify-between mt-8">
        <div className="flex font-semibold gap-3 justify-center items-center">
          <h1 className="text-[#22345C] text-[30px]">Phase 2 - Title</h1>
        </div>
      </div>
      <div className="top-10 justify-center items-center relative grid place-items-center place-content-center">
        <img
          class="rounded-xl"
          src={Image1}
          alt=""
          className="w-[500px] h-[350px] rounded-lg"
        />
      </div>
      <div className="flex justify-center items-center ">
        <div class=" bg-white w-auto rounded-2xl pt-32 pb-5 -mt-14   overflow-hidden shadow-xl   transition duration-300">
          <div class=" justify-between items-center mx-10">
            <div className="ml-2">
              <h1 class=" text-center underline text-2xl font-semibold text-[#22345C]">
                Key Components of R2 Standard Certification
              </h1>
            </div>
            <div className="mx-7 mt-4 mb-5">
              <ol class="list-decimal space-y-5 text-[#535353] text-lg font-sans font-semibold">
                <li>
                  Environmental Responsibility: The R2 Standard certification
                  emphasizes the proper handling of electronic waste to minimize
                  its impact on the environment. Certified organizations must
                  adhere to strict guidelines for safe disposal, recycling, and
                  reduction of hazardous substances commonly found in
                  electronics.
                </li>
                <li>
                  Data Security: Protecting sensitive data is paramount in
                  today's digital age. R2 Standard certification requires
                  organizations to implement robust data destruction processes
                  to ensure that any data-containing devices are thoroughly
                  sanitized before recycling or reuse.
                </li>
                <li>
                  Supply Chain Transparency: Certified organizations are
                  required to maintain transparency and accountability
                  throughout the electronics recycling supply chain. This
                  includes tracking the flow of materials, ensuring proper
                  documentation, and conducting due diligence on downstream
                  vendors.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Phase2;
